<div [formGroup]="controlFormGroup">
  <label [class.is-invalid-label]="hasErrors()">
    {{ controlName | controlNameToHuman | snakeCaseToHuman }}
    <textarea
      [name]="controlName"
      cols="10"
      [rows]="height"
      [placeholder]="'Enter ' + (controlName | controlNameToHuman | snakeCaseToHuman)"
      [class.is-invalid-input]="hasErrors()"
      [class.margin-bottom-none]="!hasErrors()"
      [formControlName]="controlName"
    ></textarea>
  </label>
</div>

<rav-field-errors [controlFormGroup]="controlFormGroup" [controlName]="controlName" [hasErrors]="hasErrors()">
</rav-field-errors>
